export default {
  signInTitle: 'お帰りなさい',
  signInSubtitle: 'アカウントにサインインして続行',
  signUpTitle: 'アカウント作成',
  signUpSubtitle: 'ペットケアの旅を始めましょう',
  forgotPasswordTitle: 'パスワードを忘れた',
  forgotPasswordSubtitle: 'メールアドレスを入力すると、パスワードリセットリンクを送信します',
  resetPasswordTitle: '新しいパスワードを作成',
  resetPasswordSubtitle: '新しいパスワードを入力してください',
  
  emailPlaceholder: 'メールアドレス',
  passwordPlaceholder: 'パスワード',
  confirmPasswordPlaceholder: 'パスワード確認',
  newPasswordPlaceholder: '新しいパスワード',
  confirmNewPasswordPlaceholder: '新しいパスワードを確認',
  
  signInButton: 'サインイン',
  signUpButton: '登録',
  sendResetEmailButton: 'リセットメールを送信',
  updatePasswordButton: 'パスワードを更新',
  continueWithGoogle: 'Google で続行',
  orDivider: 'または',
  forgotPassword: 'パスワードを忘れた？',
  backToSignIn: 'サインインに戻る',
  
  noAccount: 'アカウントをお持ちでないですか？',
  alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
  
  signingYouIn: 'サインイン中...',
  creatingAccount: 'アカウント作成中...',
  sendingResetEmail: 'メール送信中...',
  updatingPassword: 'パスワード更新中...',
  
  signInSuccess: 'サインインに成功しました！',
  accountCreatedAndSignedIn: 'アカウントが正常に作成されました！サインイン中...',
  resetEmailSent: 'パスワードリセットメールを送信しました！受信トレイをご確認ください',
  passwordUpdatedSuccess: 'パスワードが正常に更新されました！ダッシュボードにリダイレクト中...',
  
  emailRequired: 'メールアドレスを入力してください',
  emailInvalid: 'メールアドレスの形式が正しくありません',
  passwordRequired: 'パスワードを入力してください',
  passwordTooShort: 'パスワードは6文字以上である必要があります',
  confirmPasswordRequired: 'パスワードを確認してください',
  passwordMismatch: 'パスワードが一致しません',
  
  invalidLoginCredentials: 'メールアドレスまたはパスワードが間違っています',
  userAlreadyRegistered: 'このメールアドレスは既に登録されています',
  emailNotConfirmed: '先にメールアドレスを確認してください',
  emailRateLimitExceeded: 'リクエストが多すぎます。しばらくしてからもう一度お試しください',
  securityRateLimit: 'セキュリティ上の理由から、60秒後に再試行してください',
  resetRequestCooldown: 'セキュリティ上の理由から、15秒後に再試行してください',
  userNotFound: 'ユーザーが見つかりません',
  samePasswordError: '新しいパスワードは古いパスワードと異なる必要があります',
  resetLinkExpired: 'リセットリンクの有効期限が切れているか無効です',
  invalidResetLink: '無効なリセットリンク',
  resetLinkExpiredMessage: 'このリセットリンクは期限切れまたは既に使用されています。新しいパスワードリセットをリクエストしてください。',
  verifyingResetLink: 'リセットリンクを確認中...',
  
  googleSignInError: 'Googleサインインに失敗しました。後でもう一度お試しください',
  unexpectedError: '予期しないエラーが発生しました。後でもう一度お試しください',
};